<template>
    <button class="button main" :class="{TA: isTestAchat}" @click="$emit('click')" ref="button">
    {{ getLabel }}
    <SvgIcon class="loading" icon="loading" v-if="isLoading"></SvgIcon>
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters("common", ["isTestAchat"]),
        getLabel() {
            return this.label ? this.label : this.$t('next');
        }
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        label: {
            type: String
        }
    },
    mounted(){
        if(this.isTestAchat) this.$refs.button.style.fontFamily = "Lato";
    }
}
</script>


// WEBPACK FOOTER //
// src/components/NextButton.vue